import { createReducer } from '@reduxjs/toolkit';
import { setAllTranslationsAction, translationsLoadingAction } from 'store/actions/translation-actions';
import ITranslationState from 'types/translations/ITransltionState';

const initialState: ITranslationState = {
  loading: false,
  translations: [],
};

const translationsReducer = createReducer(initialState, builder => {
  return builder
    .addCase(translationsLoadingAction, (state, action) => {
      return {
        ...state,
        translationsLoading: action.payload,
      };
    })
    .addCase(setAllTranslationsAction, (state, action) => {
      return {
        ...state,
        translations: action.payload,
      };
    });
});

export default translationsReducer;
